import { ActionReducer } from '@ngrx/store';
import { GlobalState } from './index';
import { logout } from './core-actions';

/**
 * Flush the entire store when user logs out.
 * @param reducer
 */
export const flushStore = (reducer: ActionReducer<GlobalState>): ActionReducer<GlobalState> => {
  return (state, action) => {
    if (action.type === logout.type) {
      state = undefined;
    }

    return reducer(state, action);
  };
};
